<div class="p-2 rounded-md text-sm font-medium animate-fadeIn dark:text-white">
  <span>{{ data.message }}</span>
</div>
